import { render, staticRenderFns } from "./CommonAccordion.vue?vue&type=template&id=35a1fff3&scoped=true&"
import script from "./CommonAccordion.vue?vue&type=script&lang=js&"
export * from "./CommonAccordion.vue?vue&type=script&lang=js&"
import style0 from "./CommonAccordion.vue?vue&type=style&index=0&id=35a1fff3&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a1fff3",
  null
  
)

export default component.exports